import { ID, IDsFilter } from '../../../../../types';
import { FetchUsersFilters } from '../../../../../main/users/usersTypes';

export const enum UniversalFilterUsersModes {
  CONTAINS_ANY_OF = 'contains_any_of'
  // CONTAINS_ALL_OF = 'contains_all_of',
  // CONTAINS_ONLY = 'contains_only',
  // CONTAINS_NONE_OF = 'contains_none_of',
  // DOES_NOT_CONTAIN_ANY_OF = 'does_not_contain_any_of',
  // IS_EMPTY = 'is_empty',
  // IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterUsersValue = IDsFilter;

export type UniversalFilterUsersFilterState = {
  mode: UniversalFilterUsersModes;
  userIds?: ID[];
};

export type UniversalFilterUsersFilterOptions = {
  initialUsersFilters?: FetchUsersFilters;
  withoutRecentUsers?: boolean;
};

export type UniversalFilterUsersOnFilterStateChange = (
  state: UniversalFilterUsersFilterState
) => void;

export type UniversalFilterUsersOnChange = (
  value?: UniversalFilterUsersValue
) => void;
